
































































































/*
    * Method for pupulate text input control - STARTS
*/
import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";
import TextArea from "./../../Body/CardType/Form/FieldTypes/TextArea.vue";
import * as moment from 'moment';

@Component({
      components: {
        TextArea
    }
})
export default  class WorkflowComponent extends Vue {

    /*
        *  A component’s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
        *  this.$options.parent.fileName - current componets name
    */
    data() {
        // @ts-ignore
        return this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName];
    }

    /*
        * Method for show tooltip
    */
    _wfShowTooltip(event, record) {
            // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName],
                log = [];
            context.workflow.logItem = [];
            context.workflow.index = record.Value;

            //#. Check for form type
            if (context.dashboard.componentId == 0) {
                return;
            }

            let index = context.workflow.log.indexOf(context.workflow.log.find(x => x.WorkflowStepId == record.Value));

            if (index == -1) {
                // @ts-ignore
                this.workflow.tooltipContainer = false;
                return;
            }

            //#. Fetch workflow log for selected transaction id.
            context.workflow.log.filter(x => x.UpdatedOn != null).forEach(key => {
                // @ts-ignore
                key.UpdatedOn = moment(key.UpdatedOn).format(context.defaultDateWithTime);
                // @ts-ignore
                log.push(key);
            });

            //#. Updated log details
            context.workflow.pagination.page = index + 1;
            context.workflow.logItem = log;
            // @ts-ignore
            this.workflow.left = event.clientX;
            // @ts-ignore
            this.workflow.top = event.clientY;
            //#. Remove workflow components in the DOM
            // @ts-ignore
            this.workflow.tooltipContainer = false;

            Vue.nextTick(() => {
                //#. Add the component back in
                // @ts-ignore
                this.workflow.tooltipContainer = true;
            });
        }

        /*
            * Method for remove tooltip
        */
        _wfRemoveTooltip() {
            // @ts-ignore
            this.workflow.tooltipContainer = false;
        }

        /*
            * Method for reset current steps
        */
    _wfGetCurrentStep(record) {
            // @ts-ignore
            let workflowContext = this.$store.state.workflow;
            // @ts-ignore
            let context = this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName];
            // @ts-ignore
            this.workflow.tooltipContainer = false;

             //#. Reset workflow comments in the DOM
             if (context.formData[workflowContext.workflowStepId] != record.Value)
                 context.editedItem[workflowContext.workflowComments] = "";
             else
                 context.editedItem[workflowContext.workflowComments] = context.formData[workflowContext.workflowComments];

             //#. Remove component in the DOM
             workflowContext.comments = false;

             this.$nextTick(() => {
                 //#. Add the component back in
                 workflowContext.comments = true;
             });

             //#.Reset workflow status id.
             context.editedItem[workflowContext.workflowStepId] = record;

             //#. Checking custom event
             let field = context.fields.filter(x => x.value == workflowContext.workflowStepId).find(x => x);

             //#.If checking event true annotation is enable.
             if (field.event) {
                 let action = field.value;
                 action = action.charAt(0).toLowerCase() + action.slice(1);

                 //#.Change are triggered with the store.dispatch method.
                 this.$store.dispatch(context.fileName + '/' + action + 'Change', record);
             }

             if (context.disabled) {
                 //#.Triggered edit button click with the store.dispatch method.
                 // @ts-ignore
                 this.$store.dispatch('dashboard/edit', context);
             }
        }
}
